import React from "react"
import illustration from '../images/page15/illustration.svg'

const Page15 = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ height: "100%", background: backgroundColor, color: color }} className="h-100 grid-cols-12 xl:grid-cols-12">
      <div className='col-1'>
      </div>
      <div className='col-5'>
        <div className='lg:mt-8 xl:mt-6 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Come funziona Fleet Audit
        </div>
        <div className='lg:mt-4 font-family-acumin font-weight-500 xl:mt-3 lg:font-32 xl:font-28 lg:line-height-40 xl:line-height-38'>
          Prendi controllo della tua flotta,<br /> attraverso l’analisi dei dati sulla<br />mobilità quotidiana dell’azienda
        </div>
        <div className='lg:mt-3 xl:mt-2 lg:font-18 xl:font-16 lg:line-height-24 xl:line-height-22'>
          Con il servizio Fleet Audit, Edison – in un periodo di<br />
          tempo che va da uno a massimo tre mesi – raccoglie<br />
          i dati più importanti sulle vetture dell’azienda,<br />
          come i giorni di utilizzo del mezzo, la media di<br />
          chilometri per viaggio o i diversi tipi di percorsi<br />
          effettuati; il tutto, attraverso un’integrazione database<br />
          o una black box non invasiva.
        </div>
      </div>
      <div className='col-1'>

      </div>
      <div className='col-4'>
        <div className='lg:mt-9 xl:mt-7 text-center'>
          <img src={illustration} alt='Illustration'/>
        </div>
      </div>
    </div>
  )
}

export default Page15
